import type { AppProblemModel } from '~/services/api/AppProblemModel'
import { resolveProblemMessage } from '~/services/api/resolveProblemMessage'
import { hasClosureReopenTime } from './hasClosureReopenTime'
import { resolveClosureMessage } from './resolveClosureMessage'
import type { TranslateFn } from './TranslateFn'

/**
 * Canonical display message for an availability-check failure: a closure with a closed_until
 * reopen time resolves through resolveClosureMessage(); everything else falls back to the caller's resolver.
 */
export function resolveAvailabilityProblemMessage(
  problem: AppProblemModel,
  timezone: string,
  t: TranslateFn,
  fallback: string,
  resolveFallbackMessage: (
    problem: AppProblemModel,
    t: TranslateFn,
    fallback?: string
  ) => string = resolveProblemMessage
): string {
  if (!hasClosureReopenTime(problem)) {
    return resolveFallbackMessage(problem, t, fallback)
  }

  const operatorNote = problem.params?.['operator_note']
  const closedUntil = problem.params?.['closed_until']

  return resolveClosureMessage(
    {
      code: 'STORE_TEMPORARILY_CLOSED',
      params: {
        closed_until: String(closedUntil),
        operator_note: operatorNote != null ? String(operatorNote) : null
      }
    },
    timezone,
    t
  )
}
